export const appColors = {
  'siecStandardWhite': '#FFF',
  'siecStandardBlue': '#0064B7',
  'siecMediumBlue': '#0091EA',
  'siecStandarGrey': '#757575', 
  'siecStandardRed': '#FF0000'
}

export default appColors;